import { RichText } from "@/components/richText/richText.component";

import type { GetHomePageQueryResult } from "@/sanity.types";

export const SeoParagraph = ({ block }: { block: SeoParagraphBlock }) => {
  const hasTitle = Boolean(block.title);
  const hasContent = Boolean(block.content?.length);

  if (!hasTitle && !hasContent) return null;

  const headingId = `seo-paragraph-${block._key}`;

  return (
    <section
      data-testid="seo-paragraph"
      aria-labelledby={hasTitle ? headingId : undefined}
      className="container mx-auto flex flex-col gap-10 px-5 py-10 md:gap-12 md:px-8">
      <div className="flex flex-col gap-6">
        {hasTitle ? (
          <h2 id={headingId} className="headline-4 text-greyscale-headline">
            {block.title}
          </h2>
        ) : null}

        {hasContent ? (
          <div className="body-1 text-greyscale-body space-y-4">
            <RichText>{block.content}</RichText>
          </div>
        ) : null}
      </div>
    </section>
  );
};

type SeoParagraphBlock = Extract<
  NonNullable<NonNullable<GetHomePageQueryResult>["pageBuilder"]>[number],
  { _type: "seoParagraph" | "contentSection" }
>;
